export default {
  "0": {
    title: "Unranked",
    color: "",
    starts: -1,
    ends: 0,
  },
  "1": {
    title: "Just Beginning",
    color: "Bronze",
    starts: 1,
    ends: 109,
  },
  "2": {
    title: "Just Beginning",
    color: "Silver",
    starts: 109,
    ends: 218,
  },
  "3": {
    title: "Just Beginning",
    color: "Gold",
    starts: 218,
    ends: 327,
  },
  "4": {
    title: "Getting There",
    color: "Bronze",
    starts: 327,
    ends: 436,
  },
  "5": {
    title: "Getting There",
    color: "Silver",
    starts: 436,
    ends: 545,
  },
  "6": {
    title: "Getting There",
    color: "Gold",
    starts: 545,
    ends: 654,
  },
  "7": {
    title: "Rock Solid",
    color: "Bronze",
    starts: 654,
    ends: 763,
  },
  "8": {
    title: "Rock Solid",
    color: "Silver",
    starts: 763,
    ends: 872,
  },
  "9": {
    title: "Rock Solid",
    color: "Gold",
    starts: 872,
    ends: 981,
  },
  "10": {
    title: "Worthy Foe",
    color: "Bronze",
    starts: 981,
    ends: 1090,
  },
  "11": {
    title: "Worthy Foe",
    color: "Silver",
    starts: 1090,
    ends: 1200,
  },
  "12": {
    title: "Worthy Foe",
    color: "Gold",
    starts: 1200,
    ends: 1300,
  },
  "13": {
    title: "Got Swagger",
    color: "Bronze",
    starts: 1250,
    ends: 1400,
  },
  "14": {
    title: "Got Swagger",
    color: "Silver",
    starts: 1300,
    ends: 1350,
  },
  "15": {
    title: "Got Swagger",
    color: "Gold",
    starts: 1350,
    ends: 1400,
  },
  "16": {
    title: "Credible Threat",
    color: "Bronze",
    starts: 1400,
    ends: 1467,
  },
  "17": {
    title: "Credible Threat",
    color: "Silver",
    starts: 1467,
    ends: 1533,
  },
  "18": {
    title: "Credible Threat",
    color: "Gold",
    starts: 1533,
    ends: 1600,
  },
  "19": {
    title: "Hotness",
    color: "Bronze",
    starts: 1600,
    ends: 1667,
  },
  "20": {
    title: "Hotness",
    color: "Silver",
    starts: 1667,
    ends: 1733,
  },
  "21": {
    title: "Hotness",
    color: "Gold",
    starts: 1733,
    ends: 1800,
  },
  "22": {
    title: "Simply Amazing",
    color: "Bronze",
    starts: 1800,
    ends: 1867,
  },
  "23": {
    title: "Simply Amazing",
    color: "Silver",
    starts: 1867,
    ends: 1933,
  },
  "24": {
    title: "Simply Amazing",
    color: "Gold",
    starts: 1933,
    ends: 2000,
  },
  "25": {
    title: "POA",
    color: "Bronze",
    starts: 2000,
    ends: 2134,
  },
  "26": {
    title: "POA",
    color: "Silver",
    starts: 2134,
    ends: 2267,
  },
  "27": {
    title: "POA",
    color: "Gold",
    starts: 2267,
    ends: 2400,
  },
  "28": {
    title: "Vainglorious",
    color: "Bronze",
    starts: 2400,
    ends: 2600,
  },
  "29": {
    title: "Vainglorious",
    color: "Silver",
    starts: 2600,
    ends: 2800,
  },
  "30": {
    title: "Vainglorious",
    color: "Gold",
    starts: 2800,
    ends: 3000,
  },
};
